import { useEffect, useRef } from "react";
import { getId, Icon, Modal } from "@fluentui/react";
import { StyleUtils } from "../../../common/views/StyleUtils";
import { Utils } from "../../../common/views/Utils";
import { useInvoicePrintVM } from "../../viewmodels/InvoicePrintVM";
import InvoicePrintView from "./InvoicePrintView";
import ModalHeaderView from "../../../common/views/ModalHeaderView";

type InvoiceDetailProps = {
    id: string;
    onClose: () => void;
}

export default function InvoiceDetailView({ id, onClose }: InvoiceDetailProps) {
    const hasLoaded = useRef(false);
    const vm = useInvoicePrintVM();

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.get(id);
    }, [vm, id]);

    const isMobile = window.innerWidth <= 500;
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');

    return <>
        <Modal
            titleAriaId={titleId}
            subtitleAriaId={subtitleId}
            isOpen={true}
            onDismiss={onClose}
            styles={StyleUtils.getModalWidthStyles(450)}
            isBlocking={true}
            isModeless={false}
        >
            <ModalHeaderView title="Invoice Details" onClose={onClose} />

            <div
                id={subtitleId}
                className={(isMobile ? "mobile-" : "") + "popup-body"}
                style={{ maxHeight: isMobile ? "100vh" : "80vh", overflowY: "auto" }}
            >
                {!Utils.isArrayNullOrEmpty(vm.invoices) &&
                    vm.invoices.length > 0 &&
                    <InvoicePrintView
                        key={vm.listHash}
                        invoice={vm.invoices[0]}
                        bankAccounts={vm.bankAccounts}
                        contacts={vm.contacts} />}
            </div>
        </Modal>
    </>;
}